export const choiceValues = {
  COMPRESS: 1,
  MEDIUM: 2,
  BROAD: 3
};
